import { useEffect, useState } from 'react';
import ApiProvider from './api/ApiProvider';
import ApiErrorOrRender from './api/ApiErrorOrRender';
import DocumentTitle from './components/DocumentTitle';
import PageSelector from './components/PageSelector';
import CookieLayer from './components/CookieLayer';

import './App.scss';

const cookieAccepted = window.localStorage.getItem('cookieAccepted');

const App = () => {
    const [showCookie, setShowCookie] = useState(!cookieAccepted);

    useEffect(() => {
        if (showCookie) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [showCookie]);

    return (
        <ApiProvider>
            <ApiErrorOrRender>
                <DocumentTitle title="Lade..." />
                <PageSelector />

                {showCookie && <CookieLayer setShowCookie={setShowCookie} />}
            </ApiErrorOrRender>
        </ApiProvider>
    );
};

export default App;
